import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const fetchServices = createAsyncThunk(
    'services/fetchServices',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getServicesPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Service Reminder');
        }
    }
);

export const getServiceOverview = createAsyncThunk(
    'services/getServiceOverview',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getServiceOverview();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Service Overview');
        }
    }
);

export const fetchServicesReminder = createAsyncThunk(
    'services/fetchServicesReminder',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getServicesReminderPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Service Reminders');
        }
    }
);

export const deleteService = createAsyncThunk(
    'services/deleteService',
    async (serviceId, { rejectWithValue }) => {
        try {
            const response = await apiService.deleteService(serviceId);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete service');
        }
    }
);

export const servicePdfExport = createAsyncThunk(
    'services/servicePdfExport',
    async (getIds, { rejectWithValue }) => {
        try {
            const response = await apiService.servicePdfExport(getIds);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to export');
        }
    }
);

export const serviceExcelExport = createAsyncThunk(
    'services/serviceExcelExport',
    async (getIds, { rejectWithValue }) => {
        try {
            const response = await apiService.serviceExcelExport(getIds);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to export');
        }
    }
);

export const getSingleService = createAsyncThunk(
    'services/getSingleService',
    async (serviceId, { rejectWithValue }) => {
        try {
            const response = await apiService.getSingleService(serviceId);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch service');
        }
    }
);

export const fetchVehicleDropdown = createAsyncThunk(
    'services/fetchVehicleDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getVehiclesDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch vehicle dropdown');
        }
    }
);

export const fetchReasonsDropdown = createAsyncThunk(
    'services/fetchReasonsDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getReasonsDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch reasons dropdown');
        }
    }
);

export const fetchCategoriesDropdown = createAsyncThunk(
    'services/fetchCategoriesDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getCategoriesDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch categories dropdown');
        }
    }
);

export const fetchPartsList = createAsyncThunk(
    'services/fetchPartsList',
    async ({ vehicleTypeId, vehicleId }, { rejectWithValue }) => {
        try {
            const response = await apiService.getPartsList(vehicleTypeId, vehicleId);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch parts list');
        }
    }
);

export const fetchVehicleDetail = createAsyncThunk(
    'services/fetchVehicleDetail',
    async ({ vehicleId, vehicleBrandId, ref_id }, { rejectWithValue }) => {
        try {
            const response = await apiService.getVehicleDetail(vehicleId, vehicleBrandId, ref_id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch vehicle detail');
        }
    }
);

export const createServiceIssue = createAsyncThunk(
    'services/createServiceIssue',
    async (issueData, { rejectWithValue }) => {
        try {
            const response = await apiService.createServiceIssue(issueData);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create service issue');
        }
    }
);

export const updateServiceIssue = createAsyncThunk(
    'services/updateServiceIssue',
    async (issueData, { rejectWithValue }) => {
        try {
            const response = await apiService.updateServiceIssue(issueData);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update service issue');
        }
    }
);

export const createServiceEntry = createAsyncThunk(
    'services/createServiceEntry',
    async (serviceData, { rejectWithValue }) => {
        try {
            const response = await apiService.createServiceEntry(serviceData);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create service entry');
        }
    }
);

export const updateServiceEntry = createAsyncThunk(
    'services/updateServiceEntry',
    async (serviceData, { rejectWithValue }) => {
        try {
            const response = await apiService.updateServiceEntry(serviceData);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update service entry');
        }
    }
);

export const createServiceLineItem = createAsyncThunk(
    'services/createServiceLineItem',
    async (lineItemData, { rejectWithValue }) => {
        try {
            const response = await apiService.createServiceLineItem(lineItemData);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create service line item');
        }
    }
);

export const updateServiceLineItem = createAsyncThunk(
    'services/updateServiceLineItem',
    async (lineItemData, { rejectWithValue }) => {
        try {
            const response = await apiService.updateServiceLineItem(lineItemData);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update service line item');
        }
    }
);

export const deleteServiceLineItem = createAsyncThunk(
    'services/deleteServiceLineItem',
    async (serviceId, { rejectWithValue }) => {
        try {
            const response = await apiService.deleteServiceLineItem(serviceId);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete service line item');
        }
    }
);

export const updateServicePriorityApi = createAsyncThunk(
    'services/updateServicePriorityApi',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updateServicePriority(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update priority');
        }
    }
);

export const fetchServiceTagsDropdown = createAsyncThunk(
    'services/fetchServiceTagsDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getServiceTagsDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Tags dropdown');
        }
    }
);

export const updateServiceStatusApi = createAsyncThunk(
    'services/updateServiceStatusApi',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updateServiceStatus(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update service status');
        }
    }
);

const initialState = {
    getServicesPaginated: [],
    getServicesLoading: false,
    getServicesError: null,

    serviceOverviewData: null,
    serviceOverviewLoading: false,
    serviceOverviewError: null,

    vehicleData: [],
    vehicleDetail: null,
    loading: false,
    vehicleDetailLoading: false,
    createIssueLoading: false,
    createServiceLoading: false,
    createLineItemLoading: false,

    categoriesData: [],
    categoriesLoading: false,

    partsData: [],
    partsLoading: false,

    getServicesReminderLoading: true,
    getServicesReminderPaginated: [],
    getServicesReminderError: null,

    singleServiceData: null,
    singleServiceLoading: false,
    singleServiceError: null,

    updateServiceEntryLoading: false,
    updateServiceData: null,
    updateServiceError: null,

    deleteLoading: false,

    servicePdfExportLoading: false,
    servicePdfExportData: {},
    servicePdfExportError: null,

    serviceExcelExportLoading: false,
    serviceExcelExportData: {},
    serviceExcelExportError: null,

    reasonsData: [],
    reasonsLoading: false,
    error: null,

    serviceUpdateData: null,
    serviceUpdateLoading: false,
    serviceUpdateError: null,

    // For updating priority
    servicePriorityUpdateLoading: false,
    servicePriorityUpdateError: null,

    // Tags Dropdown
    serviceTagsData: [],
    serviceTagsLoading: false,
    serviceTagsError: null,

    // For updating status
    serviceStatusUpdateLoading: false,
    serviceStatusUpdateError: null,
};

const serviceSlice = createSlice({
    name: 'services',
    initialState,
    reducers: {
        clearVehicleDetail: (state) => {
            state.vehicleDetail = null;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(fetchServices.pending, (state) => {
                state.getServicesLoading = true;
                state.getServicesError = null;
            })
            .addCase(fetchServices.fulfilled, (state, action) => {
                state.getServicesLoading = false;
                state.getServicesPaginated = action.payload?.data || [];
                state.getServicesError = null;
            })
            .addCase(fetchServices.rejected, (state, action) => {
                state.getServicesLoading = false;
                state.getServicesError = action.payload;
                state.getServicesPaginated = [];
            })

            .addCase(getServiceOverview.pending, (state) => {
                state.serviceOverviewLoading = true;
                state.serviceOverviewError = null;
            })
            .addCase(getServiceOverview.fulfilled, (state, action) => {
                state.serviceOverviewLoading = false;
                state.serviceOverviewData = action.payload?.data || null;
                state.serviceOverviewError = null;
            })
            .addCase(getServiceOverview.rejected, (state, action) => {
                state.serviceOverviewLoading = false;
                state.serviceOverviewError = action.payload;
                state.serviceOverviewData = null;
            })

            .addCase(fetchServicesReminder.pending, (state) => {
                state.getServicesReminderLoading = true;
                state.getServicesReminderError = null;
            })
            .addCase(fetchServicesReminder.fulfilled, (state, action) => {
                state.getServicesReminderLoading = false;
                state.getServicesReminderPaginated = action.payload?.data || [];
                state.getServicesReminderError = null;
            })
            .addCase(fetchServicesReminder.rejected, (state, action) => {
                state.getServicesReminderLoading = false;
                state.getServicesReminderError = action.payload;
                state.getServicesReminderPaginated = [];
            })

            .addCase(getSingleService.pending, (state) => {
                state.singleServiceLoading = true;
                state.singleServiceError = null;
            })
            .addCase(getSingleService.fulfilled, (state, action) => {
                state.singleServiceLoading = false;
                state.singleServiceData = action.payload?.data || null;
                state.singleServiceError = null;
            })
            .addCase(getSingleService.rejected, (state, action) => {
                state.singleServiceLoading = false;
                state.singleServiceError = action.payload;
                state.singleServiceData = null;
            })

            .addCase(deleteService.pending, (state) => {
                state.deleteLoading = true;
                state.error = null;
            })
            .addCase(deleteService.fulfilled, (state, action) => {
                state.deleteLoading = false;
                state.error = null;
            })
            .addCase(deleteService.rejected, (state, action) => {
                state.deleteLoading = false;
                state.error = action.payload;
            })

            .addCase(fetchVehicleDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVehicleDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.vehicleData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchVehicleDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.vehicleData = [];
            })

            .addCase(fetchPartsList.pending, (state) => {
                state.partsLoading = true;
                state.error = null;
            })
            .addCase(fetchPartsList.fulfilled, (state, action) => {
                state.partsLoading = false;
                state.partsData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchPartsList.rejected, (state, action) => {
                state.partsLoading = false;
                state.error = action.payload;
                state.partsData = [];
            })

            .addCase(fetchReasonsDropdown.pending, (state) => {
                state.reasonsLoading = true;
            })
            .addCase(fetchReasonsDropdown.fulfilled, (state, action) => {
                state.reasonsLoading = false;
                state.reasonsData = action.payload?.data || [];
            })
            .addCase(fetchCategoriesDropdown.pending, (state) => {
                state.categoriesLoading = true;
            })
            .addCase(fetchCategoriesDropdown.fulfilled, (state, action) => {
                state.categoriesLoading = false;
                state.categoriesData = action.payload?.data || [];
            })
            .addCase(fetchVehicleDetail.pending, (state) => {
                state.vehicleDetailLoading = true;
                state.error = null;
            })
            .addCase(fetchVehicleDetail.fulfilled, (state, action) => {
                state.vehicleDetailLoading = false;
                state.vehicleDetail = action.payload?.data || null;
                state.error = null;
            })
            .addCase(fetchVehicleDetail.rejected, (state, action) => {
                state.vehicleDetailLoading = false;
                state.error = action.payload;
                state.vehicleDetail = null;
            })
            .addCase(createServiceIssue.pending, (state) => {
                state.createIssueLoading = true;
                state.error = null;
            })
            .addCase(createServiceIssue.fulfilled, (state, action) => {
                state.createIssueLoading = false;
                state.error = null;
            })
            .addCase(createServiceIssue.rejected, (state, action) => {
                state.createIssueLoading = false;
                state.error = action.payload;
            })
            .addCase(createServiceEntry.pending, (state) => {
                state.createServiceLoading = true;
                state.error = null;
            })
            .addCase(createServiceEntry.fulfilled, (state, action) => {
                state.createServiceLoading = false;
                state.error = null;
            })
            .addCase(createServiceEntry.rejected, (state, action) => {
                state.createServiceLoading = false;
                state.error = action.payload;
            })

            .addCase(updateServiceEntry.pending, (state) => {
                state.updateServiceEntryLoading = true;
                state.updateServiceError = null;
            })
            .addCase(updateServiceEntry.fulfilled, (state, action) => {
                state.updateServiceEntryLoading = false;
                state.updateServiceError = null;
            })
            .addCase(updateServiceEntry.rejected, (state, action) => {
                state.updateServiceEntryLoading = false;
                state.updateServiceError = action.payload;
            })

            .addCase(createServiceLineItem.pending, (state) => {
                state.createLineItemLoading = true;
                state.error = null;
            })
            .addCase(createServiceLineItem.fulfilled, (state, action) => {
                state.createLineItemLoading = false;
                state.error = null;
            })
            .addCase(createServiceLineItem.rejected, (state, action) => {
                state.createLineItemLoading = false;
                state.error = action.payload;
            })

            .addCase(servicePdfExport.pending, (state) => {
                state.servicePdfExportLoading = true;
                state.servicePdfExportError = null;
            })
            .addCase(servicePdfExport.fulfilled, (state, action) => {
                state.servicePdfExportLoading = false;
                state.servicePdfExportData = action.payload?.data || {};
                state.servicePdfExportError = null;
            })
            .addCase(servicePdfExport.rejected, (state, action) => {
                state.servicePdfExportLoading = false;
                state.servicePdfExportError = action.payload;
            })

            // Excel Export
            .addCase(serviceExcelExport.pending, (state) => {
                state.serviceExcelExportLoading = true;
                state.serviceExcelExportError = null;
            })
            .addCase(serviceExcelExport.fulfilled, (state, action) => {
                state.serviceExcelExportLoading = false;
                state.serviceExcelExportData = action.payload?.data || {};
                state.serviceExcelExportError = null;
            })
            .addCase(serviceExcelExport.rejected, (state, action) => {
                state.serviceExcelExportLoading = false;
                state.serviceExcelExportError = action.payload;
            })

            .addCase(updateServiceIssue.pending, (state) => {
                state.serviceUpdateLoading = true;
                state.serviceUpdateError = null;
            })
            .addCase(updateServiceIssue.fulfilled, (state, action) => {
                state.serviceUpdateLoading = false;
                state.serviceUpdateData = action.payload?.data || null;
                state.serviceUpdateError = null;
            })
            .addCase(updateServiceIssue.rejected, (state, action) => {
                state.serviceUpdateLoading = false;
                state.serviceUpdateError = action.payload;
                state.serviceUpdateData = null;
            })

            .addCase(deleteServiceLineItem.pending, (state) => {
                state.deleteLoading = true;
                state.error = null;
            })
            .addCase(deleteServiceLineItem.fulfilled, (state, action) => {
                state.deleteLoading = false;
                state.error = null;
            })
            .addCase(deleteServiceLineItem.rejected, (state, action) => {
                state.deleteLoading = false;
                state.error = action.payload;
            })

            // Update Service Priority
            .addCase(updateServicePriorityApi.pending, (state) => {
                state.servicePriorityUpdateLoading = true;
                state.servicePriorityUpdateError = null;
            })
            .addCase(updateServicePriorityApi.fulfilled, (state, action) => {
                state.servicePriorityUpdateLoading = false;
                state.servicePriorityUpdateError = null;
            })
            .addCase(updateServicePriorityApi.rejected, (state, action) => {
                state.servicePriorityUpdateLoading = false;
                state.servicePriorityUpdateError = action.payload;
            })

            // Fetch Service Tags Dropdown
            .addCase(fetchServiceTagsDropdown.pending, (state) => {
                state.serviceTagsLoading = true;
                state.serviceTagsError = null;
            })
            .addCase(fetchServiceTagsDropdown.fulfilled, (state, action) => {
                state.serviceTagsLoading = false;
                state.serviceTagsData = action.payload?.data || [];
                state.serviceTagsError = null;
            })
            .addCase(fetchServiceTagsDropdown.rejected, (state, action) => {
                state.serviceTagsLoading = false;
                state.serviceTagsError = action.payload;
            })

            // Fetch Service Status Dropdown
            .addCase(updateServiceStatusApi.pending, (state) => {
                state.serviceStatusUpdateLoading = true;
                state.serviceStatusUpdateError = null;
            })
            .addCase(updateServiceStatusApi.fulfilled, (state, action) => {
                state.serviceStatusUpdateLoading = false;
                state.serviceStatusUpdateError = null;
            })
            .addCase(updateServiceStatusApi.rejected, (state, action) => {
                state.serviceStatusUpdateLoading = false;
                state.serviceStatusUpdateError = action.payload;
            });
    },
});

export const { clearVehicleDetail, clearError } = serviceSlice.actions;

export default serviceSlice.reducer;
